import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M15.3 11.3a.749.749 0 0 1-.75.75h-.83v.85a.75.75 0 0 1-1.5 0v-.85h-.84a.75.75 0 1 1 0-1.5h.84V9.7a.75.75 0 0 1 1.5 0v.85h.83a.743.743 0 0 1 .75.75Zm-13.1-.46V4.5a1.125 1.125 0 0 1 1.12-1.12h2.86l1.3 1.3a.749.749 0 0 0 .53.22h3.17a1.118 1.118 0 0 1 1.11 1.13l.02 1.66 1.5-.01-.02-1.66a2.62 2.62 0 0 0-2.61-2.62H8.317l-1.31-1.3a.749.749 0 0 0-.53-.22h-3.16A2.623 2.623 0 0 0 .7 4.5v6.34a2.616 2.616 0 0 0 2.62 2.62h5.81v-1.5H3.317A1.118 1.118 0 0 1 2.2 10.837Z';
const draw24px =
  'M21.64,12h-1.5l0-2.54A2.11,2.11,0,0,0,18,7.37H13.17a.75.75,0,0,1-.53-.22l-2.11-2.1H6a2.11,2.11,0,0,0-2.11,2.1v9.7A2.11,2.11,0,0,0,6,19h8.89v1.5H6a3.61,3.61,0,0,1-3.61-3.6V7.15A3.61,3.61,0,0,1,6,3.55h4.84a.71.71,0,0,1,.53.22l2.11,2.1H18a3.61,3.61,0,0,1,3.61,3.61Zm1.61,4.78H21.58V15.1a.75.75,0,0,0-1.5,0v1.69H18.4a.75.75,0,0,0,0,1.5h1.68V20a.75.75,0,0,0,1.5,0v-1.7h1.67a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FolderPlusIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'folderPlus'),
) as IconWithRender;

FolderPlusIcon.displayName = 'FolderPlusIcon';
FolderPlusIcon.propTypes = Icon.propTypes;
FolderPlusIcon.renderIcon = (props) => <FolderPlusIcon {...props} />;
export default FolderPlusIcon;
